<template>
  <div class="content-videos">
    <h2 class="content-videos__title" v-html="title" v-if="content.title"></h2>
    <div class="content-videos__embeds">
      <ul>
        <li v-for="(item, index) in videos" :key="`video-${index}`">
          <div>
            <iframe
              width="560"
              height="315"
              :src="item.url"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentText',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    title () {
      return this.content.title
    },
    videos () {
      return this.content.list
    }
  }
}
</script>

<style lang="scss">
  .content-videos{
    width: 100%;

    &:not(:last-of-type){
      margin-bottom: layout("spacing");
    }

    // Title

    &__title{
      @include title;
      margin: 0;
      color: white;
      line-height: 1.2;
      margin-bottom: layout("spacing")*2;
      font-family: get($font-families, "secondary");
    }

    // Wysiwyg

    &__embeds{
      h3{
        @include media("small"){
          font-size: 1.8rem;
        }
        @include media("medium"){
          font-size: 2rem;
        }
        @include media("large"){
          font-size: 2.3rem;
        }

        margin: 0;
        color: white;
        line-height: 1.2;
        margin-bottom: layout("spacing")*1.5;
        font-family: get($font-families, "secondary");
        font-weight: font-weights("light");
      }

      ul{
        @include no-type-list;
      }

      li{
        @include aspect-ratio(560, 315);
        &:not(:last-of-type){
          margin-bottom: layout("spacing");
        }
      }

      iframe{
        width: 100%;
        height: 100%;
      }

      .add-margin-bottom{
        margin-bottom: layout("spacing")*2;
      }
    }
  }
</style>
